import { Injectable } from '@angular/core';
import { DateService } from './date.service';
import { FormattingUtilsService } from './formatting-utils.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerDetailsUtilsService {

  constructor(
    private dateService: DateService,
    private formattingUtils: FormattingUtilsService
  ) {}

  /**
   * Get status color for UI display
   */
  getStatusColor(status: string): string {
    return this.formattingUtils.getStatusColor(status);
  }

  /**
   * Format currency for display
   */
  formatCurrency(amount: number, currency: string = 'HUF'): string {
    return this.formattingUtils.formatCurrency(amount, currency);
  }

  /**
   * Format date for display
   */
  formatDate(date: string | Date): string {
    return this.dateService.formatDate(date);
  }

  /**
   * Open phone dialer
   */
  openPhoneDialer(phoneNumber: string): void {
    if (phoneNumber) {
      window.open(`tel:${phoneNumber}`);
    }
  }

  /**
   * Open email client
   */
  openEmailClient(email: string): void {
    if (email) {
      window.open(`mailto:${email}`);
    }
  }
}